import React from "react";
import "./styles.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Exercise from "./pages/exercise.tsx";
import Class from "./pages/Class.tsx";
import Instructions from "./pages/instructions";


function App() {

  // BEGIN exercises

  const boomerang = {
    url1: "https://dxhordylwv8gl.cloudfront.net/Boomerang/34_Boomerang.mp4",
    url2: "https://dxhordylwv8gl.cloudfront.net/Boomerang/head_Boomerang.mp4",
    url3: "https://dxhordylwv8gl.cloudfront.net/Boomerang/square_Boomerang.mp4",
    url4: "https://dxhordylwv8gl.cloudfront.net/Boomerang/overhead_Boomerang.mp4",
    audioSource: require("./audio/audioBoomerang.m4a"),
    title: 'Boomerang',
    level: 'Advanced',
    apparatus: 'Mat',
    props: 'None',
    body: 'Sarah'
  };

  const crissCross = {
    url1: "https://dxhordylwv8gl.cloudfront.net/CrissCross/34_so5_CC.mp4",
    url2: "https://dxhordylwv8gl.cloudfront.net/CrissCross/head_so5_CC.mp4",
    url3: "https://dxhordylwv8gl.cloudfront.net/CrissCross/square_so5_CC.mp4",
    url4: "https://dxhordylwv8gl.cloudfront.net/CrissCross/overhead_so5_CC.mp4",
    audioSource: require("./audio/audioCrissCross.wav"),
    title: 'Criss Cross',
    level: 'Beginner',
    apparatus: 'Mat',
    props: 'None',
    body: 'Sarah'
  };

  const doubleLegKicks = {
    url1: "https://dxhordylwv8gl.cloudfront.net/DoubleLegKicks/34_DLKs.mp4",
    url2: "https://dxhordylwv8gl.cloudfront.net/DoubleLegKicks/head_DLKs.mp4",
    url3: "https://dxhordylwv8gl.cloudfront.net/DoubleLegKicks/square_DLKs.mp4",
    url4: "https://dxhordylwv8gl.cloudfront.net/DoubleLegKicks/overhead_DLKs.mp4",
    audioSource: require("./audio/audioDoubleLegKicks.wav"),
    title: 'Double Leg Kicks',
    level: 'Intermediate',
    apparatus: 'Mat',
    props: 'None',
    body: 'Sarah'
  };

  const doubleLegStretch = {
    url1: "https://dxhordylwv8gl.cloudfront.net/DoubleLegStretch/34_so5_DLS.mp4",
    url2: "https://dxhordylwv8gl.cloudfront.net/DoubleLegStretch/head_so5_DLS.mp4",
    url3: "https://dxhordylwv8gl.cloudfront.net/DoubleLegStretch/square_so5_DLS.mp4",
    url4: "https://dxhordylwv8gl.cloudfront.net/DoubleLegStretch/overhead_so5_DLS.mp4",
    audioSource: require("./audio/audioDoubleLegStretch.wav"),
    title: 'Double Leg Stretch',
    level: 'Beginner',
    apparatus: 'Mat',
    props: 'None',
    body: 'Sarah'
  };

  const fetal5 = {
    url1: "https://dxhordylwv8gl.cloudfront.net/Fetal5/34_Fetal5.mp4",
    url2: "https://dxhordylwv8gl.cloudfront.net/Fetal5/head_Fetal5.mp4",
    url3: "https://dxhordylwv8gl.cloudfront.net/Fetal5/square_Fetal5.mp4",
    url4: "https://dxhordylwv8gl.cloudfront.net/Fetal5/overhead_Fetal5.mp4",
    audioSource: require("./audio/audioFetal5.wav"),
    title: 'Fetal 5',
    level: 'Intermediate',
    apparatus: 'Mat',
    props: 'None',
    body: 'Sarah'
  };

  const hiScissorsAndBicycles = {
    url1: "https://dxhordylwv8gl.cloudfront.net/HiScissorsnBicycles/34_hiScissors.mp4",
    url2: "https://dxhordylwv8gl.cloudfront.net/HiScissorsnBicycles/head_hiScissors.mp4",
    url3: "https://dxhordylwv8gl.cloudfront.net/HiScissorsnBicycles/square_hiScissors.mp4",
    url4: "https://dxhordylwv8gl.cloudfront.net/HiScissorsnBicycles/overhead_hiScissors.mp4",
    audioSource: require("./audio/audioHighScissorBikes.wav"),
    title: 'High Scissors & Bicycles',
    level: 'Advanced',
    apparatus: 'Mat',
    props: 'None',
    body: 'Sarah'
  };

  const hundred = {
    url1: "https://dxhordylwv8gl.cloudfront.net/Hundred/34_Hundred.mp4",
    url2: "https://dxhordylwv8gl.cloudfront.net/Hundred/head_Hundred.mp4",
    url3: "https://dxhordylwv8gl.cloudfront.net/Hundred/square_Hundred.mp4",
    url4: "https://dxhordylwv8gl.cloudfront.net/Hundred/overhead_Hundred.mp4",
    audioSource: require("./audio/audioHundred.wav"),
    title: 'Hundred',
    level: 'Beginner',
    apparatus: 'Mat',
    props: 'None',
    body: 'Sarah'
  };

  const jackKnife = {
    url1: "https://dxhordylwv8gl.cloudfront.net/JackKnife/34_JackKnife_2ndshoot.mp4",
    url2: "https://dxhordylwv8gl.cloudfront.net/JackKnife/head_JackKnife_2ndshoot.mp4",
    url3: "https://dxhordylwv8gl.cloudfront.net/JackKnife/square_JackKnife_2ndshoot.mp4",
    url4: "https://dxhordylwv8gl.cloudfront.net/JackKnife/overhead_JackKnife_2ndshoot.mp4",
    audioSource: require("./audio/audioJackKnife.wav"),
    title: 'Jack Knife',
    level: 'Intermediate',
    apparatus: 'Mat',
    props: 'None',
    body: 'Sarah'
  };

  const kneelSideKicks = {
    url1: "https://dxhordylwv8gl.cloudfront.net/KneelSideKicks/34_KneelSideKicks_2.mp4",
    url2: "https://dxhordylwv8gl.cloudfront.net/KneelSideKicks/head_KneelSideKicks_2.mp4",
    url3: "https://dxhordylwv8gl.cloudfront.net/KneelSideKicks/square_KneelSideKicks_2.mp4",
    url4: "https://dxhordylwv8gl.cloudfront.net/KneelSideKicks/overhead_KneelSideKicks_2.mp4",
    audioSource: require("./audio/audioKneelSideKicks.wav"),
    title: 'Kneeling Side Kicks',
    level: 'Advanced',
    apparatus: 'Mat',
    props: 'None',
    body: 'Sarah'
  };

  const legPullBack = {
    url1: "https://dxhordylwv8gl.cloudfront.net/LegPullBack/34_ControlFront.mp4",
    url2: "https://dxhordylwv8gl.cloudfront.net/LegPullBack/head_ControlFront.mp4",
    url3: "https://dxhordylwv8gl.cloudfront.net/LegPullBack/square_ControlFront.mp4",
    url4: "https://dxhordylwv8gl.cloudfront.net/LegPullBack/overhead_ControlFront.mp4",
    audioSource: require("./audio/audioLegPull.wav"),
    title: 'Leg Pull Back',
    level: 'Intermediate',
    apparatus: 'Mat',
    props: 'None',
    body: 'Sarah'
  };

  const lowerLift = {
    url1: "https://dxhordylwv8gl.cloudfront.net/LowerLift_LL/34_so5_LL.mp4",
    url2: "https://dxhordylwv8gl.cloudfront.net/LowerLift_LL/head_so5_LL.mp4",
    url3: "https://dxhordylwv8gl.cloudfront.net/LowerLift_LL/square_so5_LL.mp4",
    url4: "https://dxhordylwv8gl.cloudfront.net/LowerLift_LL/overhead_so5_LL.mp4",
    audioSource: require("./audio/audioLowerLift.wav"),
    title: 'Lower Lift',
    level: 'Advanced',
    apparatus: 'Mat',
    props: 'None',
    body: 'Sarah'
  };

  const marching = {
    url1: "https://dxhordylwv8gl.cloudfront.net/Marching/34_Marching.mp4",
    url2: "https://dxhordylwv8gl.cloudfront.net/Marching/head_Marching.mp4",
    url3: "https://dxhordylwv8gl.cloudfront.net/Marching/square_Marching.mp4",
    url4: "https://dxhordylwv8gl.cloudfront.net/Marching/overhead_Marching.mp4",
    audioSource: require("./audio/audioMarching.wav"),
    title: 'Marching',
    level: 'Beginner',
    apparatus: 'Mat',
    props: 'None',
    body: 'Sarah'
  };

  const mermaid = {
    url1: "https://dxhordylwv8gl.cloudfront.net/Mermaid/34_Mermaid.mp4",
    url2: "https://dxhordylwv8gl.cloudfront.net/Mermaid/head_Mermaid.mp4",
    url3: "https://dxhordylwv8gl.cloudfront.net/Mermaid/square_Mermaid.mp4",
    url4: "https://dxhordylwv8gl.cloudfront.net/Mermaid/overhead_Mermaid.mp4",
    audioSource: require("./audio/audioMermaid.wav"),
    title: 'Mermaid',
    level: 'Intermediate',
    apparatus: 'Mat',
    props: 'None',
    body: 'Sarah'
  };

  const neckPull = {
    url1: "https://dxhordylwv8gl.cloudfront.net/NeckPull/34_neckpull.mp4",
    url2: "https://dxhordylwv8gl.cloudfront.net/NeckPull/head_neckpull.mp4",
    url3: "https://dxhordylwv8gl.cloudfront.net/NeckPull/square_neckpull.mp4",
    url4: "https://dxhordylwv8gl.cloudfront.net/NeckPull/overhead_neckpull.mp4",
    audioSource: require("./audio/audioNeckPull.wav"),
    title: 'Neck Pull',
    level: 'Intermediate',
    apparatus: 'Mat',
    props: 'None',
    body: 'Sarah'
  };

  const openLegRocker = {
    url1: "https://dxhordylwv8gl.cloudfront.net/OpenLegRocker/34_RockerFull.mp4",
    url2: "https://dxhordylwv8gl.cloudfront.net/OpenLegRocker/head_RockerFull.mp4",
    url3: "https://dxhordylwv8gl.cloudfront.net/OpenLegRocker/square_RockerFull.mp4",
    url4: "https://dxhordylwv8gl.cloudfront.net/OpenLegRocker/overhead_RockerFull.mp4",
    audioSource: require("./audio/audioOpenLegRocker.wav"),
    title: 'Open Leg Rocker',
    level: 'Intermediate',
    apparatus: 'Mat',
    props: 'None',
    body: 'Sarah'
  };

  const pelvicTilt = {
    url1: "https://dxhordylwv8gl.cloudfront.net/PelvicTilt/34_pelvictilt_1.mp4",
    url2: "https://dxhordylwv8gl.cloudfront.net/PelvicTilt/head_pelvictilt_1.mp4",
    url3: "https://dxhordylwv8gl.cloudfront.net/PelvicTilt/square_pelvictilt_1.mp4",
    url4: "https://dxhordylwv8gl.cloudfront.net/PelvicTilt/overhead_pelvictilt_1.mp4",
    audioSource: require("./audio/audioPelvicTilt.wav"),
    title: 'Pelvic Tilt',
    level: 'Beginner',
    apparatus: 'Mat',
    props: 'None',
    body: 'Sarah'
  };

  const pushUp = {
    url1: "https://dxhordylwv8gl.cloudfront.net/PushUp/34_pushup.mp4",
    url2: "https://dxhordylwv8gl.cloudfront.net/PushUp/head_pushup.mp4",
    url3: "https://dxhordylwv8gl.cloudfront.net/PushUp/square_pushup.mp4",
    url4: "https://dxhordylwv8gl.cloudfront.net/PushUp/overhead_pushup.mp4",
    audioSource: require("./audio/audioPushUp.wav"),
    title: 'Push Up',
    level: 'Intermediate',
    apparatus: 'Mat',
    props: 'None',
    body: 'Sarah'
  };

  const rollLikeBall = {
    url1: "https://dxhordylwv8gl.cloudfront.net/RollLikeBall/34_RollBall.mp4",
    url2: "https://dxhordylwv8gl.cloudfront.net/RollLikeBall/head_RollBall.mp4",
    url3: "https://dxhordylwv8gl.cloudfront.net/RollLikeBall/square_RollBall.mp4",
    url4: "https://dxhordylwv8gl.cloudfront.net/RollLikeBall/overhead_RollBall.mp4",
    audioSource: require("./audio/audioRollLikeBall.wav"),
    title: 'Rolling Like A Ball',
    level: 'Beginner',
    apparatus: 'Mat',
    props: 'None',
    body: 'Sarah'
  };

  const rollOver = {
    url1: "https://dxhordylwv8gl.cloudfront.net/RollOver/34_RollOver.mp4",
    url2: "https://dxhordylwv8gl.cloudfront.net/RollOver/head_RollOver.mp4",
    url3: "https://dxhordylwv8gl.cloudfront.net/RollOver/square_RollOver.mp4",
    url4: "https://dxhordylwv8gl.cloudfront.net/RollOver/overhead_RollOver.mp4",
    audioSource: require("./audio/audioRollOver.wav"),
    title: 'Roll Over',
    level: 'Advanced',
    apparatus: 'Mat',
    props: 'None',
    body: 'Sarah'
  };

  const rollUp = {
    url1: "https://dxhordylwv8gl.cloudfront.net/RollUp/34_RollUp.mp4",
    url2: "https://dxhordylwv8gl.cloudfront.net/RollUp/head_RollUp.mp4",
    url3: "https://dxhordylwv8gl.cloudfront.net/RollUp/square_RollUp.mp4",
    url4: "https://dxhordylwv8gl.cloudfront.net/RollUp/overhead_RollUp.mp4",
    audioSource: require("./audio/audioRollUp.m4a"),
    title: 'Roll Up',
    level: 'Beginner',
    apparatus: 'Mat',
    props: 'None',
    body: 'Sarah'
  };

  const saw = {
    url1: "https://dxhordylwv8gl.cloudfront.net/Saw/34_saw.mp4",
    url2: "https://dxhordylwv8gl.cloudfront.net/Saw/head_saw.mp4",
    url3: "https://dxhordylwv8gl.cloudfront.net/Saw/square_saw.mp4",
    url4: "https://dxhordylwv8gl.cloudfront.net/Saw/overhead_saw.mp4",
    audioSource: require("./audio/audioSaw.m4a"),
    title: 'Saw',
    level: 'Beginner',
    apparatus: 'Mat',
    props: 'None',
    body: 'Sarah'
  };

  const scissors = {
    url1: "https://dxhordylwv8gl.cloudfront.net/Scissors/34_so5_SCI.mp4",
    url2: "https://dxhordylwv8gl.cloudfront.net/Scissors/head_so5_SCI.mp4",
    url3: "https://dxhordylwv8gl.cloudfront.net/Scissors/square_so5_SCI.mp4",
    url4: "https://dxhordylwv8gl.cloudfront.net/Scissors/overhead_so5_SCI.mp4",
    audioSource: require("./audio/audioScissors.wav"),
    title: 'Scissors',
    level: 'Beginner',
    apparatus: 'Mat',
    props: 'None',
    body: 'Sarah'
  };

  const seal = {
    url1: "https://dxhordylwv8gl.cloudfront.net/Seal/34_seal.mp4",
    url2: "https://dxhordylwv8gl.cloudfront.net/Seal/head_seal.mp4",
    url3: "https://dxhordylwv8gl.cloudfront.net/Seal/square_seal.mp4",
    url4: "https://dxhordylwv8gl.cloudfront.net/Seal/overhead_seal.mp4",
    audioSource: require("./audio/audioSeal.wav"),
    title: 'Seal',
    level: 'Beginner',
    apparatus: 'Mat',
    props: 'None',
    body: 'Sarah'
  };

  const serratusPushUp = {
    url1: "https://dxhordylwv8gl.cloudfront.net/SerratusPushUp/34_serratus.mp4",
    url2: "https://dxhordylwv8gl.cloudfront.net/SerratusPushUp/head_serratus.mp4",
    url3: "https://dxhordylwv8gl.cloudfront.net/SerratusPushUp/square_serratus.mp4",
    url4: "https://dxhordylwv8gl.cloudfront.net/SerratusPushUp/overhead_serratus.mp4",
    audioSource: require("./audio/audioSerratusPushUp.wav"),
    title: 'Serratus Push Up',
    level: 'Intermediate',
    apparatus: 'Mat',
    props: 'None',
    body: 'Sarah'
  };

  const shoulderBridge = {
    url1: "https://dxhordylwv8gl.cloudfront.net/ShoulderBridge/34_bridge.mp4",
    url2: "https://dxhordylwv8gl.cloudfront.net/ShoulderBridge/head_bridge.mp4",
    url3: "https://dxhordylwv8gl.cloudfront.net/ShoulderBridge/square_bridge.mp4",
    url4: "https://dxhordylwv8gl.cloudfront.net/ShoulderBridge/overhead_bridge.mp4",
    audioSource: require("./audio/audioShoulderBridge.m4a"),
    title: 'Shoulder Bridge',
    level: 'Beginner',
    apparatus: 'Mat',
    props: 'None',
    body: 'Sarah'
  };

  const sideBend = {
    url1: "https://dxhordylwv8gl.cloudfront.net/SideBend/34_SideBend_2.mp4",
    url2: "https://dxhordylwv8gl.cloudfront.net/SideBend/head_SideBend_2.mp4",
    url3: "https://dxhordylwv8gl.cloudfront.net/SideBend/square_SideBend_2.mp4",
    url4: "https://dxhordylwv8gl.cloudfront.net/SideBend/overhead_SideBend_2.mp4",
    audioSource: require("./audio/audioSideBend.wav"),
    title: 'Side Bend',
    level: 'Advanced',
    apparatus: 'Mat',
    props: 'None',
    body: 'Sarah'
  };

  const sideKicks = {
    url1: "https://dxhordylwv8gl.cloudfront.net/SideKicks/34_SideKicks_2.mp4",
    url2: "https://dxhordylwv8gl.cloudfront.net/SideKicks/head_SideKicks_2.mp4",
    url3: "https://dxhordylwv8gl.cloudfront.net/SideKicks/square_SideKicks_2.mp4",
    url4: "https://dxhordylwv8gl.cloudfront.net/SideKicks/overhead_SideKicks_2.mp4",
    audioSource: require("./audio/audioSideKicks.m4a"),
    title: 'Side Kicks',
    level: 'Beginner',
    apparatus: 'Mat',
    props: 'None',
    body: 'Sarah'
  }

  const singleLegCircle = {
    url1: "https://dxhordylwv8gl.cloudfront.net/SingleLegCircle/34_SLC.mp4",
    url2: "https://dxhordylwv8gl.cloudfront.net/SingleLegCircle/head_SLC.mp4",
    url3: "https://dxhordylwv8gl.cloudfront.net/SingleLegCircle/square_SLC.mp4",
    url4: "https://dxhordylwv8gl.cloudfront.net/SingleLegCircle/overhead_SLC.mp4",
    audioSource: require("./audio/audioSingleLegCircles.wav"),
    title: 'Single Leg Circle',
    level: 'Beginner',
    apparatus: 'Mat',
    props: 'None',
    body: 'Sarah'
  };

  const singleLegKicks = {
    url1: "https://dxhordylwv8gl.cloudfront.net/SingleLegKicks/34_SLKs.mp4",
    url2: "https://dxhordylwv8gl.cloudfront.net/SingleLegKicks/head_SLKs.mp4",
    url3: "https://dxhordylwv8gl.cloudfront.net/SingleLegKicks/square_SLKs.mp4",
    url4: "https://dxhordylwv8gl.cloudfront.net/SingleLegKicks/overhead_SLKs.mp4",
    audioSource: require("./audio/audioSingleLegKicks.wav"),
    title: 'Single Leg Kicks',
    level: 'Beginner',
    apparatus: 'Mat',
    props: 'None',
    body: 'Sarah'
  };

  const singleLegStretch = {
    url1: "https://dxhordylwv8gl.cloudfront.net/SingleLegStretch_SLS/34_so5_SLS.mp4",
    url2: "https://dxhordylwv8gl.cloudfront.net/SingleLegStretch_SLS/head_so5_SLS.mp4",
    url3: "https://dxhordylwv8gl.cloudfront.net/SingleLegStretch_SLS/square_so5_SLS.mp4",
    url4: "https://dxhordylwv8gl.cloudfront.net/SingleLegStretch_SLS/overhead_so5_SLS.mp4",
    audioSource: require("./audio/audioSingleLegStretch.wav"),
    title: 'Single Leg Stretch',
    level: 'Beginner',
    apparatus: 'Mat',
    props: 'None',
    body: 'Sarah'
  };

  const spineStretch = {
    url1: "https://dxhordylwv8gl.cloudfront.net/SpineStretch/34_spinestretch.mp4",
    url2: "https://dxhordylwv8gl.cloudfront.net/SpineStretch/head_spinestretch.mp4",
    url3: "https://dxhordylwv8gl.cloudfront.net/SpineStretch/square_spinestretch.mp4",
    url4: "https://dxhordylwv8gl.cloudfront.net/SpineStretch/overhead_spinestretch.mp4",
    audioSource: require("./audio/audioSpineStretch.wav"),
    title: 'Spine Stretch',
    level: 'Beginner',
    apparatus: 'Mat',
    props: 'None',
    body: 'Sarah'
  };

  const spineTwist = {
    url1: "https://dxhordylwv8gl.cloudfront.net/SpineTwist/34_SpineTwist_1.mp4",
    url2: "https://dxhordylwv8gl.cloudfront.net/SpineTwist/head_SpineTwist_1.mp4",
    url3: "https://dxhordylwv8gl.cloudfront.net/SpineTwist/square_SpineTwist_1.mp4",
    url4: "https://dxhordylwv8gl.cloudfront.net/SpineTwist/overhead_SpineTwist_1.mp4",
    audioSource: require("./audio/audioSpineTwist.wav"),
    title: 'Spine Twist',
    level: 'Advanced',
    apparatus: 'Mat',
    props: 'None',
    body: 'Sarah'
  };

  const star = {
    url1: "https://dxhordylwv8gl.cloudfront.net/Star/34_Star_2.mp4",
    url2: "https://dxhordylwv8gl.cloudfront.net/Star/head_Star_2.mp4",
    url3: "https://dxhordylwv8gl.cloudfront.net/Star/square_Star_2.mp4",
    url4: "https://dxhordylwv8gl.cloudfront.net/Star/overhead_Star_2.mp4",
    audioSource: require("./audio/audioStar.m4a"),
    title: 'Star',
    level: 'Advanced',
    apparatus: 'Mat',
    props: 'None',
    body: 'Sarah'
  };

  const swan = {
    url1: "https://dxhordylwv8gl.cloudfront.net/Swan/34_swan.mp4",
    url2: "https://dxhordylwv8gl.cloudfront.net/Swan/head_swan.mp4",
    url3: "https://dxhordylwv8gl.cloudfront.net/Swan/square_swan.mp4",
    url4: "https://dxhordylwv8gl.cloudfront.net/Swan/overhead_swan.mp4",
    audioSource: require("./audio/audioSwan.m4a"),
    title: 'Swan',
    level: 'Beginner',
    apparatus: 'Mat',
    props: 'None',
    body: 'Sarah'
  };

  const swanDive = {
    url1: "https://dxhordylwv8gl.cloudfront.net/SwanDive/34_SwanDive_2ndShoot.mp4",
    url2: "https://dxhordylwv8gl.cloudfront.net/SwanDive/head_SwanDive_2ndShoot.mp4",
    url3: "https://dxhordylwv8gl.cloudfront.net/SwanDive/square_SwanDive_2ndShoot.mp4",
    url4: "https://dxhordylwv8gl.cloudfront.net/SwanDive/overhead_SwanDive_2ndShoot.mp4",
    audioSource: require("./audio/audioSwanDive.wav"),
    title: 'Swan Dive',
    level: 'Advanced',
    apparatus: 'Mat',
    props: 'None',
    body: 'Sarah'
  };

  const swanPrep = {
    url1: "https://dxhordylwv8gl.cloudfront.net/SwanPrep/swanprep_34.mp4",
    url2: "https://dxhordylwv8gl.cloudfront.net/SwanPrep/swanprep_head.mp4",
    url3: "https://dxhordylwv8gl.cloudfront.net/SwanPrep/swanprep_square.mp4",
    url4: "https://dxhordylwv8gl.cloudfront.net/SwanPrep/swanprep_overhead.mp4",
    audioSource: require("./audio/audioSwanPrep.m4a"),
    title: 'Swan Prep',
    level: 'Beginner',
    apparatus: 'Mat',
    props: 'None',
    body: 'Sarah'
  };

  const swimming = {
    url1: "https://dxhordylwv8gl.cloudfront.net/Swimming/34_swimming.mp4",
    url2: "https://dxhordylwv8gl.cloudfront.net/Swimming/head_swimming.mp4",
    url3: "https://dxhordylwv8gl.cloudfront.net/Swimming/square_swimming.mp4",
    url4: "https://dxhordylwv8gl.cloudfront.net/Swimming/overhead_swimming.mp4",
    audioSource: require("./audio/audioSwimming.wav"),
    title: 'Swimming',
    level: 'Intermediate',
    apparatus: 'Mat',
    props: 'None',
    body: 'Sarah'
  };

  const teaser1 = {
    url1: "https://dxhordylwv8gl.cloudfront.net/Teaser1/34_Teaser_2.mp4",
    url2: "https://dxhordylwv8gl.cloudfront.net/Teaser1/head_Teaser_2.mp4",
    url3: "https://dxhordylwv8gl.cloudfront.net/Teaser1/square_Teaser_2.mp4",
    url4: "https://dxhordylwv8gl.cloudfront.net/Teaser1/overhead_Teaser_2.mp4",
    audioSource: require("./audio/audioTeaser1.wav"),
    title: 'Teaser 1',
    level: 'Beginner',
    apparatus: 'Mat',
    props: 'None',
    body: 'Sarah'
  };

  const teaser3 = {
    url1: "https://dxhordylwv8gl.cloudfront.net/Teaser3/34_Teaser_3.mp4",
    url2: "https://dxhordylwv8gl.cloudfront.net/Teaser3/head_Teaser_3.mp4",
    url3: "https://dxhordylwv8gl.cloudfront.net/Teaser3/square_Teaser_3.mp4",
    url4: "https://dxhordylwv8gl.cloudfront.net/Teaser3/overhead_Teaser_3.mp4",
    audioSource: require("./audio/audioTeaser3.wav"),
    title: 'Teaser 3',
    level: 'Intermediate',
    apparatus: 'Mat',
    props: 'None',
    body: 'Sarah'
  };

  const teaser4 = {
    url1: "https://dxhordylwv8gl.cloudfront.net/Teaser4/34_TeaserIV_2.mp4",
    url2: "https://dxhordylwv8gl.cloudfront.net/Teaser4/head_TeaserIV_2.mp4",
    url3: "https://dxhordylwv8gl.cloudfront.net/Teaser4/square_TeaserIV_2.mp4",
    url4: "https://dxhordylwv8gl.cloudfront.net/Teaser4/overhead_TeaserIV_2.mp4",
    audioSource: require("./audio/audioTeaser4.wav"),
    title: 'Teaser 4',
    level: 'Advanced',
    apparatus: 'Mat',
    props: 'None',
    body: 'Sarah'
  };

  // END exercises

  // BEGIN classes

  const postSickReset = {
    url1: "https://dxhordylwv8gl.cloudfront.net/RecordedClasses/PostSickReset/34_postsick_20.mp4",
    url2: "https://dxhordylwv8gl.cloudfront.net/RecordedClasses/PostSickReset/head_postsick_20.mp4",
    url3: "https://dxhordylwv8gl.cloudfront.net/RecordedClasses/PostSickReset/square_postsick_20.mp4",
    url4: "https://dxhordylwv8gl.cloudfront.net/RecordedClasses/PostSickReset/overhead_postsick_20.mp4",
    title: 'Post Sick Reset',
    level: 'Advanced',
    apparatus: 'Mat',
    props: 'None',
    body: 'Sarah'
  };

  const lilBit = {
    url1: "https://dxhordylwv8gl.cloudfront.net/RecordedClasses/LilBit/34_lilbit_20.mp4",
    url2: "https://dxhordylwv8gl.cloudfront.net/RecordedClasses/LilBit/head_lilbit_20.mp4",
    url3: "https://dxhordylwv8gl.cloudfront.net/RecordedClasses/LilBit/square_lilbit_20.mp4",
    url4: "https://dxhordylwv8gl.cloudfront.net/RecordedClasses/LilBit/overhead_lilbit_20.mp4",
    title: 'A Lil Bit of Everything',
    level: 'Advanced',
    apparatus: 'Mat',
    props: 'None',
    body: 'Sarah'
  };

  const reformerOnTheMat = {
    url1: "https://dxhordylwv8gl.cloudfront.net/RecordedClasses/ReformerOnTheMat/34_refonmat.mp4",
    url2: "https://dxhordylwv8gl.cloudfront.net/RecordedClasses/ReformerOnTheMat/head_refonmat.mp4",
    url3: "https://dxhordylwv8gl.cloudfront.net/RecordedClasses/ReformerOnTheMat/squarewaudio_refonmat.mp4",
    url4: "https://dxhordylwv8gl.cloudfront.net/RecordedClasses/ReformerOnTheMat/overhead_refonmat.mp4",
    title: 'Reformer On The Mat',
    level: 'Advanced',
    apparatus: 'Mat',
    props: 'None',
    body: 'Sarah'
  };

  const fourDPilates = {
    url1: "https://dxhordylwv8gl.cloudfront.net/RecordedClasses/4DPilates/34_spinalplanes.mp4",
    url2: "https://dxhordylwv8gl.cloudfront.net/RecordedClasses/4DPilates/head_spinalplanes.mp4",
    url3: "https://dxhordylwv8gl.cloudfront.net/RecordedClasses/4DPilates/squarewaudio_spinalplanes.mp4",
    url4: "https://dxhordylwv8gl.cloudfront.net/RecordedClasses/4DPilates/overhead_spinalplanes.mp4",
    title: '4D Pilates',
    level: 'Advanced',
    apparatus: 'Mat',
    props: 'None',
    body: 'Sarah'
  };

  // END classes

  return (
    <Router>
      <Routes>
        <Route path="/" element={<Instructions />} />
        <Route exact path="/boomerang" element={<Exercise originalLinks={boomerang}/>} />
        <Route exact path="/crissCross" element={<Exercise originalLinks={crissCross}/>} />
        <Route exact path="/doubleLegKicks" element={<Exercise originalLinks={doubleLegKicks}/>} />
        <Route exact path="/doubleLegStretch" element={<Exercise originalLinks={doubleLegStretch}/>} />
        <Route exact path="/fetal5" element={<Exercise originalLinks={fetal5}/>} />
        <Route exact path="/hiScissorsAndBicycles" element={<Exercise originalLinks={hiScissorsAndBicycles}/>} />
        <Route exact path="/hundred" element={<Exercise originalLinks={hundred}/>} />
        <Route exact path="/jackKnife" element={<Exercise originalLinks={jackKnife}/>} />
        <Route exact path="/kneelSideKicks" element={<Exercise originalLinks={kneelSideKicks}/>} />
        <Route exact path="/legPullBack" element={<Exercise originalLinks={legPullBack}/>} />
        <Route exact path="/lowerLift" element={<Exercise originalLinks={lowerLift}/>} />
        <Route exact path="/marching" element={<Exercise originalLinks={marching}/>} />
        <Route exact path="/mermaid" element={<Exercise originalLinks={mermaid}/>} />
        <Route exact path="/neckPull" element={<Exercise originalLinks={neckPull}/>} />
        <Route exact path="/openLegRocker" element={<Exercise originalLinks={openLegRocker}/>} />
        <Route exact path="/pelvicTilt" element={<Exercise originalLinks={pelvicTilt}/>} />
        <Route exact path="/pushUp" element={<Exercise originalLinks={pushUp}/>} />
        <Route exact path="/rollLikeBall" element={<Exercise originalLinks={rollLikeBall}/>} />
        <Route exact path="/rollOver" element={<Exercise originalLinks={rollOver}/>} />
        <Route exact path="/rollUp" element={<Exercise originalLinks={rollUp}/>} />
        <Route exact path="/saw" element={<Exercise  originalLinks={saw}/>} />
        <Route exact path="/scissors" element={<Exercise originalLinks={scissors}/>} />
        <Route exact path="/seal" element={<Exercise originalLinks={seal}/>} />
        <Route exact path="/serratusPushUp" element={<Exercise originalLinks={serratusPushUp}/>} />
        <Route exact path="/shoulderBridge" element={<Exercise originalLinks={shoulderBridge}/>} />
        <Route exact path="/sideBend" element={<Exercise originalLinks={sideBend}/>} />
        <Route exact path="/sideKicks" element={<Exercise originalLinks={sideKicks}/>} />
        <Route exact path="/singleLegCircle" element={<Exercise originalLinks={singleLegCircle}/>} />
        <Route exact path="/singleLegKicks" element={<Exercise originalLinks={singleLegKicks}/>} />
        <Route exact path="/singleLegStretch" element={<Exercise originalLinks={singleLegStretch}/>} />
        <Route exact path="/spineStretch" element={<Exercise originalLinks={spineStretch}/>} />
        <Route exact path="/spineTwist" element={<Exercise originalLinks={spineTwist}/>} />
        <Route exact path="/star" element={<Exercise originalLinks={star}/>} />
        <Route exact path="/swan" element={<Exercise originalLinks={swan}/>} />
        <Route exact path="/swanDive" element={<Exercise originalLinks={swanDive}/>} />
        <Route exact path="/swanPrep" element={<Exercise originalLinks={swanPrep}/>} />
        <Route exact path="/swimming" element={<Exercise originalLinks={swimming}/>} />
        <Route exact path="/teaser1" element={<Exercise originalLinks={teaser1}/>} />
        <Route exact path="/teaser3" element={<Exercise originalLinks={teaser3}/>} />
        <Route exact path="/teaser4" element={<Exercise originalLinks={teaser4}/>} />

        <Route exact path="/postSickReset" element={<Class originalLinks={postSickReset}/>} />
        <Route exact path="/lilBit" element={<Class originalLinks={lilBit}/>} />
        <Route exact path="/reformerOnTheMat" element={<Class originalLinks={reformerOnTheMat}/>} />
        <Route exact path="/fourDPilates" element={<Class originalLinks={fourDPilates}/>} />
      </Routes>
    </Router>
  );
}

export default App;